import React, { useState, useEffect, useRef } from "react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import Srcset from "./Srcset";
import styles from "../QuickBuyComp/QuickBuyComp.module.scss";
import wishliststyles from "../PlpWishlistComp/WishlistPlpOptions.module.scss";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import Link from "next/link";
import { openMiniCart } from "@/redux/actions/addToCartAction";
import { useDispatch } from "react-redux";
import { reportError } from "@/helpers/errorHelper";
import style from "../common/common.module.scss";
import { hasLocalItem } from "@/helpers/plpHelper";

const PLPSwatches = ({
  data,
  selected, // optional prop (set selected swatch from parent component)
  setSelected, // optional prop (if selected swatch data needs to be passed to parent)
  type,
  hexCodeArray,
  handle, // Only for color picker swatches
  setQuickBuyClicked,
  link,	
  loading,
  showOptions,
  searchPopupEnabled,
  bundleQuickBuy, // Enable GA event for bundle
  wishlistComp,
  fireWishlistAction,
  variantMap
}) => {
  const dispatch = useDispatch()
  const [active, setActive] = useState(false);
  const [showOptionsState, setShowOptionsState] = useState(showOptions); // Track visibility
  const wrapperRef = useRef(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    if (selected) setActive(selected);
  }, [selected]);

  const handleBlur = (e) => {    
    if (wrapperRef.current && !wrapperRef.current.contains(e.relatedTarget)) {
        let wishlistElement = e.target.closest(".plp_wishlist");
        if (wishlistElement) {
            wishlistElement.classList.remove(...Array.from(wishlistElement.classList).filter((cls)=> cls.includes("opened-w") || cls.includes("WishlistPlpOptions_opened")));
        } 
        let quickbuyElement = e.target.closest(".quick_buy ");
        if(quickbuyElement){
          quickbuyElement.classList.remove(...Array.from(quickbuyElement.classList).filter((cls)=> cls.includes("QuickBuyComp_opened")));
        } 
        setShowOptionsState(false);
        setIsDrawerOpen(false);
    }
};

const handleFocus = () => {
  if (!isDrawerOpen) { 
      setShowOptionsState(true); 
      setIsDrawerOpen(true); 
  }
};
  const isDesktop= useMediaQuery("(min-width: 1025px)");
  const isTablet = useMediaQuery("(max-width: 1024px)");
  let sliceCount = '';
  if (isDesktop) {
    if(searchPopupEnabled && !wishlistComp)	
      sliceCount = 5	
    else if(searchPopupEnabled && wishlistComp)
      sliceCount = 3
    else if(wishlistComp)		
      sliceCount = 4
    else 	
      sliceCount = 5;	
    showOptions= true;
  }
  if (isTablet) {
    if (wishlistComp) {
      showOptions= true;
    }
  }

  const isValidUrl = (_string) => {
    const matchPattern =
      /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
    return matchPattern.test(_string);
  };

  const selectHandler = (e) => {
    e.preventDefault();
    if(wishlistComp) {
      fireWishlistAction(e.target.value);
      return;
    }
    if (setSelected) setSelected(e.target.value);
    setActive(e.target.value);
    setQuickBuyClicked(true);
  };

  const handleTabIndexing = (e) =>{
    if(e?.key=='Enter'){
      try {
          const activeElement = document.activeElement;
          document?.querySelector?.(".focusElement")?.previousElementSibling?.click();
          // retain tab indexing sequence within same carousel - wishlist with multiple options
          if (activeElement?.tagName === 'LABEL') {
            if(wishlistComp){
              const wishlistParentDiv = activeElement?.closest('.wish-wrapper');
              if (wishlistParentDiv) {
                wishlistParentDiv?.focus();
              }
            }else{
              // retain focus to mini cart - quick buy with multiple options
              const qbParentDiv = activeElement?.closest('.quick_buy');
              if(qbParentDiv){
                setTimeout(() => {
                  qbParentDiv?.focus();
                }, 0);
              }
            }
          }
      }catch (error) {
        reportError(error); // Log error using reportError function
        reportError("errol in PLP swatches enter event");
      }
    }
  }

  const Swatch = (ele, key, handle,type,isSticky) => {
    const sizes = ele.split("/");
    let hasLocal = hasLocalItem(variantMap,ele);
    let primarySize = sizes.find(size => size.includes("US"))?.trim() || sizes[0]?.trim();
    const hasMultipleSizes = sizes.length > 1;
    if (!hasMultipleSizes) primarySize = sizes[0]?.trim();
    return(
    <>
      <div className={`swatches-item ${type=="letter"|| type=="style" ? "showHover" : " "} ${ type=="sizes" || type=="size" ? "noColor" : "rounded"} ${ele === active ? "active" : ""} ${wishlistComp ? 'down': ''} ${isDesktop ? 'tooltip': ''}`} data-text={`${data[key]}`} key={key}>
        <input
          type="radio"
          id={`color-swateche-${isSticky ? "sticky" : ""}-${handle}-${key}`}
          name={`color-swateche-${isSticky ? "sticky" : ""}`}
          value={ele}
          onClick={(e) => {selectHandler(e)}}
          aria-label={`color-swateche-${isSticky ? "sticky" : ""}-${handle}-${key}`}
          className = {`wish-test ${bundleQuickBuy ? 'ga-bundle-quick-buy': ''}`}
          tabIndex={-1}
        />
         {/* To display the fast shipping badge for Quick Buy PLP */}
         {hasLocal && !wishlistComp ? (<span className={`fast_shipping_dot ${style.fast_shipping_badge} ${style.quick_buy_badge}`}></span>) : null}
          {isValidUrl(ele) ? (
            <Srcset className="swatches-type" src={ele} />
          ) : type == "color" && hexCodeArray[key] ? (
            hexCodeArray[key].length === 1 ? (
              <label style={{ backgroundColor: `#${hexCodeArray[key][0]}` }} 
                className={`small-icon ${ele === active ? "active" : ""}`}
                htmlFor={`color-swateche-${isSticky ? "sticky" : ""}-${handle}-${key}`}
                onClick={() => {
                  if(!wishlistComp) {
                    return;
                  }
                  fireWishlistAction(ele);
                }}
                tabIndex={0}
                onKeyDown={(e)=>{handleTabIndexing(e)}}
              ></label>
            ) : (
              <div className={styles.main}>
                {hexCodeArray[key].map((hexCode, index) => {
                  return (
                    <label style={{ backgroundColor: `#${hexCode}` }} className={`small-icon ${ele === active ? "active" : ""}`}	key={index}
                    htmlFor={`color-swateche-${isSticky ? "sticky" : ""}-${handle}-${key}`}	
                    onClick={() => {
                      if(!wishlistComp) {
                        return;
                      }
                      fireWishlistAction(ele);
                    }}
                    onKeyDown={(e)=>{handleTabIndexing(e)}}
                    tabIndex={0}
                  ></label>
                  );
                })}
              </div>
            )
          ) : (
            <label className={`xx-small small-icon ${ele === active ? "active" : ""}`}	
              key={key}
              onClick={() => {
                if(!wishlistComp) {
                  return;
                }
                fireWishlistAction(ele);
              }}
              tabIndex={0}
              htmlFor={`color-swateche-${isSticky ? "sticky" : ""}-${handle}-${key}`}	
              onKeyDown={(e)=>{handleTabIndexing(e)}}
            >{primarySize}</label>
          )}
      </div>
    </>
  );
}



  return (
    <div 
    ref={wrapperRef}
    onBlur={handleBlur}
    onFocus={handleFocus}
    className={`${!wishlistComp ? styles.qb_options : wishliststyles.wishlist_options} ${loading ? "loading" : ""}`} >
          {showOptions && <ul>
           {sliceCount!='' ? data.slice(0, sliceCount).map((ele, i) => (
            <li className={`xx-small-md xx-small-sm ${searchPopupEnabled && wishlistComp ? 'reduced_spacing' : '' }`} key={`${i}`}>
              {Swatch(ele, `${i}`,handle,type)}
            </li>
          )) : data.map((ele, i) => (
            <li className="xx-small-md xx-small-sm" key={`${i}`}>
              {Swatch(ele, `${i}`,handle,type)}
            </li>
          ))}
          <li className={`plus-icon ${data.length > sliceCount ? '' : 'd-none' } ${searchPopupEnabled ? styles : '' }` }
          tabIndex={0}
          onKeyDown={(e)=>{
            if(e?.key == "Enter")
              {window.location.href = link;}
          }}
          >
            <a onClick={() => {
               window.location.href = link;
              }} >
                <Srcset
                requirePath={true}
                svgFile={true}
                src={"images/Icons/Plus/large.svg"}
                alt="See more"
                />
            </a>
          </li>
          </ul>}
    </div>
  );
};

export default PLPSwatches;
